import { render, staticRenderFns } from "./AtomIconRemove.vue?vue&type=template&id=2b937188&scoped=true&"
import script from "./AtomIconRemove.vue?vue&type=script&lang=ts&"
export * from "./AtomIconRemove.vue?vue&type=script&lang=ts&"
import style0 from "./AtomIconRemove.vue?vue&type=style&index=0&id=2b937188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b937188",
  null
  
)

export default component.exports